import React, { Component }	from "react";
import { withRouter }		from "react-router";
import { connect }			from "react-redux";

import { getRolesSelector }			from "../../reducers/roles";
import { rightsSelector }			from "../../reducers/rights";
import { getTrueLockingsSelector }	from "../../reducers/lockings";

import { getExtraColsNumberSelector } from "../../reducers/app";

import { addRightsRequest, deleteRightsRequest } from "./rightsActions";

import RightsTableData			from "./RightsTableData";
import RightsTableDataCheckbox	from "./RightsTableDataCheckbox";

class RolesRightsContainer extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="rights-table__row u-flex">
				{this.props.roles.map(role =>
					this.renderRoleCol(role)
				)}
				{this.generateEmptyCols()}
			</div>
		);
	}

	renderRoleCol(role) {
		const hasAllRights = Object.keys(this.props.rightsMap[role.role_id]).length === this.props.lockings.length;
		return (
			<RightsTableDataCheckbox
				key={role.role_id}
				checked={hasAllRights}
				onClick={() => this.props.toggleRights(role, this.props.lockings, hasAllRights)} />
		);
	}

	generateEmptyCols() {
		const cols = [];
		const emptyColsNumber = this.props.extraColsNumber;
		for(let i = 0; i < emptyColsNumber; i++) {
			cols.push(
				this.renderEmptyCol(i)
			);
		}
		return cols;
	}

	renderEmptyCol(index) {
		return (
			<RightsTableData key={index} />
		);
	}
}

function mapStateToProps(state) {
	return {
		roles			: getRolesSelector(state),
		rightsMap		: rightsSelector(state),
		lockings		: getTrueLockingsSelector(state),
		extraColsNumber	: getExtraColsNumberSelector(state)
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	const { projectId } = ownProps.params;
	return {
		toggleRights: (role, lockings, hasAllRights) => {
			const toggle = hasAllRights
				? deleteRightsRequest
				: addRightsRequest;

			dispatch(
				toggle(projectId, [role], lockings)
			);
		}
	}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RolesRightsContainer));



// WEBPACK FOOTER //
// ./src/js/plan/rights/RolesAllRightsContainer.js